import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { getActiveModuleTabs } from '@root/components/falconReact/navbar/navConfig';
import { useTheme } from '@root/context/ThemeContext';

interface PageHeaderSkeletonProps {
  isRegionFilter?: boolean;
}

function PageHeaderSkeleton({ isRegionFilter }: PageHeaderSkeletonProps) {
  const { isDarkMode } = useTheme();
  const { pathname, search } = useLocation();

  const skeletonColor = isDarkMode ? '#2D3748' : '#E2E8F0';

  // Same self-gating source as ModuleTabs, so pages without tabs get no tab placeholders and
  // the real labels drive the pill widths — nothing shifts when the actual tabs render.
  const module = getActiveModuleTabs(pathname, search);

  return (
    <div>
      <Box marginBottom="10px" display="flex" justifyContent="space-between" position="relative">
        <Skeleton
          height="20px"
          width="150px"
          style={{
            transform: 'none',
            backgroundColor: skeletonColor,
          }}
        />
        {module ? (
          <Box
            position="absolute"
            left="50%"
            top="50%"
            display="flex"
            alignItems="center"
            gap="8px"
            style={{ transform: 'translate(-50%, -50%)' }}>
            {module.tabs.map(tab => (
              <Skeleton
                key={tab.to}
                height="28px"
                // Mirrors .ModuleTabs__Tab: 16px horizontal padding either side + ~7px per glyph at 13px.
                width={`${tab.name.length * 7 + 32}px`}
                style={{
                  transform: 'none',
                  borderRadius: '15px',
                  backgroundColor: skeletonColor,
                }}
              />
            ))}
          </Box>
        ) : null}
        {isRegionFilter ? (
          <Skeleton
            height="30px"
            width="150px"
            style={{
              transform: 'none',
              backgroundColor: skeletonColor,
            }}
          />
        ) : null}
      </Box>
    </div>
  );
}

export default PageHeaderSkeleton;
